import { PhoneCall, UserCheck, Wrench } from "lucide-react";
import { Reveal } from "./Reveal";

const PASSI = [
  {
    num: "01",
    icon: PhoneCall,
    titolo: "Chiamaci o scrivici",
    desc: "Raccontaci il problema al telefono, in chat o con il modulo: un operatore reale risponde in pochi istanti, a qualsiasi ora.",
  },
  {
    num: "02",
    icon: UserCheck,
    titolo: "Tecnico in arrivo",
    desc: "Attiviamo subito il tecnico più vicino a te: conosci nome e orario di arrivo prima ancora che parta.",
  },
  {
    num: "03",
    icon: Wrench,
    titolo: "Problema risolto",
    desc: "Riparazione eseguita con ricambi garantiti, preventivo rispettato e pagamento come preferisci: contanti, carta o bonifico.",
  },
];

export function ComeFunziona() {
  return (
    <section id="come-funziona" className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-32">
      <Reveal className="text-center">
        <p className="overline-label">Come funziona</p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Dalla chiamata alla riparazione, <span className="text-amber-400">tre passi.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
        {PASSI.map((p, i) => (
          <Reveal key={p.num} delay={i * 0.12}>
            <div
              data-testid={`passo-${p.num}`}
              className="group relative h-full rounded-2xl border border-slate-800 bg-slatecard p-8 text-center transition-all duration-300 hover:-translate-y-1 hover:border-amber-500/50"
            >
              <span className="font-mono text-5xl font-bold text-slate-800 transition-colors group-hover:text-amber-500/40">
                {p.num}
              </span>
              <span className="mt-6 inline-flex rounded-xl bg-amber-500/15 p-3 text-amber-400">
                <p.icon size={22} strokeWidth={1.8} />
              </span>
              <h3 className="mt-5 font-display text-xl font-semibold text-white">{p.titolo}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
